const calendarCollection = (typeof calendarJson !== 'undefined') ? JSON.parse(calendarJson) : {};
const limitYearMonths = calendarCollection.limit_year_months != null ? new Date(calendarCollection.limit_year_months) : new Date();

var dateString = nowStr;
// Checking month validate
var param_arr = window.location.href.split('#');
if (param_arr.length == 2 && param_arr[1] != "calendar") {

  if (param_arr[1].length == 6) {
    var curr_month = dateString.substring(0, 7).replace("-", "");
    var input_month = param_arr[1];
    if (parseInt(input_month) >= parseInt(curr_month)) {
      var dateString = param_arr[1].substring(0, 4) + '-' + param_arr[1].substring(4, 6) + '-01';
    } else {
      window.location.href = param_arr[0];
    }
  } else {
    window.location.href = "/experience_days/";
  }

  // Checking date exist in month
  var date_exist = new Date(dateString.replace(' ', 'T'));
  var year_exist = date_exist.getFullYear();
  var month_exist = date_exist.getMonth();
  var count = 0;
  $.each(calendarData.model, function(index, item) {
    if (item.year == year_exist && item.month == month_exist && (item.title == 'holiday_event' || item.title == 'eventday')) {
      count++;
    }
    if ((index + 1) == calendarData.model.length) {
      if (count == 0) {
        window.location.href = "/experience_days/";
      }
    }
  });
}

var Calendar = function(model, options, date) {
  // Default Values
  this.Options = {
    Color: '',
    LinkColor: '',
    NavShow: true,
    NavVertical: false,
    NavLocation: '',
    DateTimeShow: true,
    DateTimeFormat: 'mmm, yyyy',
    DatetimeLocation: '',
    EventClick: '',
    EventTargetWholeDay: false,
    DisabledDays: [],
    ModelChange: model
  };
  // Overwriting default values
  for (var key in options) {
    this.Options[key] = typeof options[key] == 'string' ? options[key].toLowerCase() : options[key];
  }
  model ? this.Model = model : this.Model = {};
  this.Today = new Date(dateString.replace(' ', 'T'));
  this.Selected = this.Today
  this.Today.Month = this.Today.getMonth();
  this.Today.Year = this.Today.getFullYear();
  if (date) {
    this.Selected = date
  }
  this.Selected.Month = this.Selected.getMonth();
  this.Selected.Year = this.Selected.getFullYear();
  this.Selected.Days = new Date(this.Selected.Year, (this.Selected.Month + 1), 0).getDate();
  this.Selected.FirstDay = new Date(this.Selected.Year, (this.Selected.Month), 1).getDay();
  this.Selected.LastDay = new Date(this.Selected.Year, (this.Selected.Month + 1), 0).getDay();
  this.Prev = new Date(this.Selected.Year, (this.Selected.Month - 1), 1);
  if (this.Selected.Month == 0) {
    this.Prev = new Date(this.Selected.Year - 1, 11, 1);
  }
  this.Prev.Days = new Date(this.Prev.getFullYear(), (this.Prev.getMonth() + 1), 0).getDate();
};

function createCalendar(calendar, element, adjuster) {
  if (typeof adjuster !== 'undefined') {
    var newDate = new Date(calendar.Selected.Year, calendar.Selected.Month + adjuster, 1);
    calendar = new Calendar(calendar.Model, calendar.Options, newDate);
    element.innerHTML = '';
  } else {
    for (var key in calendar.Options) {
      typeof calendar.Options[key] != 'function' && typeof calendar.Options[key] != 'object' && calendar.Options[key] ? element.className += " " + key + "-" + calendar.Options[key] : 0;
    }
  }
  var months = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

  function AddSidebar() {
    var sidebar = document.createElement('div');
    sidebar.className += 'cld-sidebar';
    var monthList = document.createElement('ul');
    monthList.className += 'cld-monthList';
    for (var i = 0; i < months.length - 3; i++) {
      var x = document.createElement('li');
      x.className += 'cld-month';
      var n = i - (4 - calendar.Selected.Month);
      // Account for overflowing month values
      if (n < 0) {
        n += 12;
      } else if (n > 11) {
        n -= 12;
      }
      // Add Appropriate Class
      if (i == 0) {
        x.className += ' cld-rwd cld-nav';
        x.addEventListener('click', function() {
          typeof calendar.Options.ModelChange == 'function' ? calendar.Model = calendar.Options.ModelChange() : calendar.Model = calendar.Options.ModelChange;
          createCalendar(calendar, element, -1);
        });
        x.innerHTML += '<svg height="15" width="15" viewBox="0 0 100 75" fill="rgba(255,255,255,0.5)"><polyline points="0,75 100,75 50,0"></polyline></svg>';
      } else if (i == months.length - 4) {
        x.className += ' cld-fwd cld-nav';
        x.addEventListener('click', function() {
          typeof calendar.Options.ModelChange == 'function' ? calendar.Model = calendar.Options.ModelChange() : calendar.Model = calendar.Options.ModelChange;
          createCalendar(calendar, element, 1);
        });
        x.innerHTML += '<svg height="15" width="15" viewBox="0 0 100 75" fill="rgba(255,255,255,0.5)"><polyline points="0,0 100,0 50,75"></polyline></svg>';
      } else {
        if (i < 4) {
          x.className += ' cld-pre';
        } else if (i > 4) {
          x.className += ' cld-post';
        } else {
          x.className += ' cld-curr';
        }
        //prevent losing var adj value (for whatever reason that is happening)
        (function() {
          var adj = (i - 4);
          //x.addEventListener('click', function(){createCalendar(calendar, element, adj);console.log('kk', adj);} );
          x.addEventListener('click', function() {
            typeof calendar.Options.ModelChange == 'function' ? calendar.Model = calendar.Options.ModelChange() : calendar.Model = calendar.Options.ModelChange;
            createCalendar(calendar, element, adj);
          });
          x.setAttribute('style', 'opacity:' + (1 - Math.abs(adj) / 4));
          x.innerHTML += months[n].substr(0, 3);
        }()); // immediate invocation
        if (n == 0) {
          var y = document.createElement('li');
          y.className += 'cld-year';
          if (i < 5) {
            y.innerHTML += calendar.Selected.Year;
          } else {
            y.innerHTML += calendar.Selected.Year + 1;
          }
          monthList.appendChild(y);
        }
      }
      monthList.appendChild(x);
    }
    sidebar.appendChild(monthList);
    if (calendar.Options.NavLocation) {
      document.getElementById(calendar.Options.NavLocation).innerHTML = "";
      document.getElementById(calendar.Options.NavLocation).appendChild(sidebar);
    } else {
      element.appendChild(sidebar);
    }
  }
  var mainSection = document.createElement('div');
  mainSection.className += "cld-main";

  function addEvent() {
    let dayOffs = document.querySelectorAll('.cld-number.off');
    let dayOffsLength = dayOffs.length;
    for (let i = 0; i < dayOffsLength; i++) {
      let parentDayOff = dayOffs[i].parentElement;
      parentDayOff.classList.add('off');
    }
    let _eventdays = document.querySelectorAll('.cld-number.eventday');
    let _eventdayLength = _eventdays.length;
    for (let j = 0; j < _eventdayLength; j++) {
      let parentEventday = _eventdays[j].parentElement;
      if (_eventdays[j].classList.contains('eventday')) {
        parentEventday.classList.add('eventday');
        parentEventday.dataset.id = _eventdays[j].dataset.id;
        parentEventday.dataset.date = _eventdays[j].dataset.date;
      }
    }
    let _holidayEventdays = document.querySelectorAll('.cld-number.holiday_event');
    let _holidayEventdayLength = _holidayEventdays.length;
    for (let j = 0; j < _holidayEventdayLength; j++) {
      let parentHolidayEventday = _holidayEventdays[j].parentElement;
      if (_holidayEventdays[j].classList.contains('holiday_event')) {
        parentHolidayEventday.classList.add('holiday_event');
        parentHolidayEventday.dataset.id = _holidayEventdays[j].dataset.id;
        parentHolidayEventday.dataset.date = _holidayEventdays[j].dataset.date;
      }
    }
    let dayHolidays = document.querySelectorAll('.cld-number.holiday');
    let dayHolidaysLength = dayHolidays.length;
    for (let i = 0; i < dayHolidaysLength; i++) {
      let parentDaydayHoliday = dayHolidays[i].parentElement;
      parentDaydayHoliday.classList.add('holiday');
    }
  }

  function AddDateTime() {
    var datetime = document.createElement('div');
    datetime.className += "cld-datetime";
    if (calendar.Options.NavShow && !calendar.Options.NavVertical) {
      var rwd = document.createElement('div');
      // let currentDate = new Date();
      let currentDate = new Date(dateString.replace(' ', 'T'));
      let currentTime = currentDate.getTime();
      let calendarTime = calendar.Selected.getTime();
      if (calendarTime <= currentTime) {
        rwd.className += " cld-rwd cld-nav cld-left disable";
      } else {
        rwd.className += " cld-rwd cld-nav cld-left";
      }
      rwd.addEventListener('click', function() {
        selectTimezone = document.getElementById('timezone');
        if (selectTimezone != null) {
          selectTimezone.innerHTML = '<option value="">選択してください</option>';
        }
        createCalendar(calendar, element, -1);
        addEvent();
        toggleSelectedClass();
      });
      rwd.innerHTML = '<img src="/assets/img/svg/icon_left.svg" alt="">';
      datetime.appendChild(rwd);
    }
    var today = document.createElement('div');
    today.className += ' today';
    today.innerHTML = '<span class="yearHead">' + calendar.Selected.Year + '</span>' + '<span class="monthHead"><span class="ttl">' + months[calendar.Selected.Month] + '</span><span class="txt">月</span></span>';
    datetime.appendChild(today);
    if (calendar.Options.NavShow && !calendar.Options.NavVertical) {
      var fwd = document.createElement('div');
      fwd.className += " cld-fwd cld-nav cld-right";
      if (calendar.Selected.getMonth() == limitYearMonths.getMonth() && calendar.Selected.getFullYear() == limitYearMonths.getFullYear()) {
        fwd.className += " disable";
      }

      fwd.addEventListener('click', function() {
        selectTimezone = document.getElementById('timezone');
        if (selectTimezone != null) {
          selectTimezone.innerHTML = '<option value="">選択してください</option>';
        }
        createCalendar(calendar, element, 1);
        addEvent();
        toggleSelectedClass();
      });
      fwd.innerHTML = '<img src="/assets/img/svg/icon_right.svg" alt="">';
      datetime.appendChild(fwd);
    }
    if (calendar.Options.DatetimeLocation) {
      document.getElementById(calendar.Options.DatetimeLocation).innerHTML = "";
      document.getElementById(calendar.Options.DatetimeLocation).appendChild(datetime);
    } else {
      mainSection.appendChild(datetime);
    }
  }

  function AddLabels() {
    var labels = document.createElement('ul');
    labels.className = 'cld-labels';
    var labelsList = ["日", "月", "火", "水", "木", "金", "土"];
    for (var i = 0; i < labelsList.length; i++) {
      var label = document.createElement('li');
      i === 0 ? label.className += "cld-label sun" : label.className += "cld-label";
      label.innerHTML = labelsList[i];
      labels.appendChild(label);
    }
    mainSection.appendChild(labels);
  }

  function AddDays() {
    // Create Number Element
    function DayNumber(n) {
      var number = document.createElement('p');
      number.className += "cld-number";
      number.innerHTML += n;
      return number;
    }
    var days = document.createElement('ul');
    days.className += "cld-days";
    // Previous Month's Days
    for (var i = 0; i < (calendar.Selected.FirstDay); i++) {
      var day = document.createElement('li');
      day.className += "cld-day prevMonth";
      //Disabled Days
      var d = i % 7;
      for (var q = 0; q < calendar.Options.DisabledDays.length; q++) {
        if (d == calendar.Options.DisabledDays[q]) {
          day.className += " disableDay";
        }
      }
      var number = DayNumber((calendar.Prev.Days - calendar.Selected.FirstDay) + (i + 1));
      day.appendChild(number);
      days.appendChild(day);
    }
    // Current Month's Days
    for (var i = 0; i < calendar.Selected.Days; i++) {
      var day = document.createElement('li');
      //Disabled Days
      var d = (i + calendar.Selected.FirstDay) % 7;
      if (d == 0) {
        day.className += "cld-day currMonth sun";
      } else {
        day.className += "cld-day currMonth";
      }
      for (var q = 0; q < calendar.Options.DisabledDays.length; q++) {
        if (d == calendar.Options.DisabledDays[q]) {
          day.className += " disableDay";
        }
      }
      var number = DayNumber(i + 1);
      // Check Date against Event Dates
      for (var n = 0; n < calendar.Model.length; n++) {
        var evDate = calendar.Model[n].Date;
        var evTitle = calendar.Model[n].Title;
        var toDate = new Date(calendar.Selected.Year, calendar.Selected.Month, (i + 1));
        if (evDate.getTime() == toDate.getTime()) {
          if (evTitle == 'off') {
            number.className += " off";
          } else if (evTitle == 'holiday') {
            number.className += " holiday";
          } else if (evTitle == 'eventday') {
            number.className += " eventday";
            number.dataset.id = calendar.Model[n].OcId;
            number.dataset.date = calendar.Model[n].FullDate;
          } else if (evTitle == 'holiday_event') {
            number.className += " holiday_event";
            number.dataset.id = calendar.Model[n].OcId;
            number.dataset.date = calendar.Model[n].FullDate;
          }
          var title = document.createElement('span');
          title.className += "cld-title";
          if (typeof calendar.Model[n].Link == 'function' || calendar.Options.EventClick) {
            var a = document.createElement('a');
            a.setAttribute('href', '#');
            a.innerHTML += calendar.Model[n].Title;
            if (calendar.Options.EventClick) {
              var z = calendar.Model[n].Link;
              if (typeof calendar.Model[n].Link != 'string') {
                a.addEventListener('click', calendar.Options.EventClick.bind.apply(calendar.Options.EventClick, [null].concat(z)));
                if (calendar.Options.EventTargetWholeDay) {
                  day.className += " clickable";
                  day.addEventListener('click', calendar.Options.EventClick.bind.apply(calendar.Options.EventClick, [null].concat(z)));
                }
              } else {
                a.addEventListener('click', calendar.Options.EventClick.bind(null, z));
                if (calendar.Options.EventTargetWholeDay) {
                  day.className += " clickable";
                  day.addEventListener('click', calendar.Options.EventClick.bind(null, z));
                }
              }
            } else {
              a.addEventListener('click', calendar.Model[n].Link);
              if (calendar.Options.EventTargetWholeDay) {
                day.className += " clickable";
                day.addEventListener('click', calendar.Model[n].Link);
              }
            }
            title.appendChild(a);
          } else {
            title.innerHTML += '<a href="' + calendar.Model[n].Link + '">' + calendar.Model[n].Title + '</a>';
          }
          number.appendChild(title);
        }
      }
      day.appendChild(number);
      // If Today..
      if ((i + 1) == calendar.Today.getDate() && calendar.Selected.Month == calendar.Today.Month && calendar.Selected.Year == calendar.Today.Year) {
        day.className += " today";
      }
      days.appendChild(day);
    }
    // Next Month's Days
    // Always same amount of days in calander
    var extraDays = 13;
    if (days.children.length > 35) {
      extraDays = 6;
    } else if (days.children.length < 29) {
      extraDays = 20;
    }
    for (var i = 0; i < (extraDays - calendar.Selected.LastDay); i++) {
      var day = document.createElement('li');
      day.className += "cld-day nextMonth";
      //Disabled Days
      var d = (i + calendar.Selected.LastDay + 1) % 7;
      for (var q = 0; q < calendar.Options.DisabledDays.length; q++) {
        if (d == calendar.Options.DisabledDays[q]) {
          day.className += " disableDay";
        }
      }
      var number = DayNumber(i + 1);
      day.appendChild(number);
      days.appendChild(day);
    }
    mainSection.appendChild(days);
  }
  if (calendar.Options.Color) {
    mainSection.innerHTML += '<style>.cld-main{color:' + calendar.Options.Color + ';}</style>';
  }
  if (calendar.Options.LinkColor) {
    mainSection.innerHTML += '<style>.cld-title a{color:' + calendar.Options.LinkColor + ';}</style>';
  }
  element.appendChild(mainSection);
  if (calendar.Options.NavShow && calendar.Options.NavVertical) {
    AddSidebar();
  }
  if (calendar.Options.DateTimeShow) {
    AddDateTime();
  }
  AddLabels();
  AddDays();
}

function calendar(el, data, settings) {
  var obj = new Calendar(data, settings);
  createCalendar(obj, el);
}
var events = [];
if (typeof calendarJson !== 'undefined') {
  calendarCollection.model.forEach((item) => {
    events.push({
      'Date': new Date(item.year, item.month, item.day),
      'Title': item.title,
      'OcId': item.id,
      'FullDate': item.date,
    });
  });
}
var element = document.getElementById('calendar');
var settings = {};
calendar(element, events, settings);

function addEventLoad() {
  let dayOffs = document.querySelectorAll('.cld-number.off');
  let dayOffsLength = dayOffs.length;
  for (let i = 0; i < dayOffsLength; i++) {
    let parentDayOff = dayOffs[i].parentElement;
    parentDayOff.classList.add('off');
  }
  let _eventdays = document.querySelectorAll('.cld-number.eventday');
  let _eventdayLength = _eventdays.length;
  for (let j = 0; j < _eventdayLength; j++) {
    let parentEventday = _eventdays[j].parentElement;
    if (_eventdays[j].classList.contains('eventday')) {
      parentEventday.classList.add('eventday');
      parentEventday.dataset.id = _eventdays[j].dataset.id;
      parentEventday.dataset.date = _eventdays[j].dataset.date;
    }
  }
  let _holidayEventdays = document.querySelectorAll('.cld-number.holiday_event');
  let _holidayEventdayLength = _holidayEventdays.length;
  for (let j = 0; j < _holidayEventdayLength; j++) {
    let parentHolidayEventday = _holidayEventdays[j].parentElement;
    if (_holidayEventdays[j].classList.contains('holiday_event')) {
      parentHolidayEventday.classList.add('holiday_event');
      parentHolidayEventday.dataset.id = _holidayEventdays[j].dataset.id;
      parentHolidayEventday.dataset.date = _holidayEventdays[j].dataset.date;
    }
  }
  let dayHolidays = document.querySelectorAll('.cld-number.holiday');
  let dayHolidaysLength = dayHolidays.length;
  for (let i = 0; i < dayHolidaysLength; i++) {
    let parentDaydayHoliday = dayHolidays[i].parentElement;
    parentDaydayHoliday.classList.add('holiday');
  }
}

function toggleSelectedClass() {
  let dayOpens = document.querySelectorAll('.currMonth.eventday');
  let dayOpensLength = dayOpens.length;
  let holidayEventDays = document.querySelectorAll('.currMonth.holiday_event');
  let holidayEventDaysLength = holidayEventDays.length;
  for (let k = 0; k < dayOpensLength; k++) {
    dayOpens[k].addEventListener('click', function() {
      let ele = this;
      for (let k = 0; k < dayOpensLength; k++) {
        if (dayOpens[k] != ele && dayOpens[k].classList.contains('selected')) {
          dayOpens[k].classList.add('eventday');
          dayOpens[k].classList.remove('selected');
        }
      }
      for (let k = 0; k < holidayEventDaysLength; k++) {
        if (holidayEventDays[k] != ele && holidayEventDays[k].classList.contains('selected')) {
          holidayEventDays[k].classList.add('holiday_event');
          holidayEventDays[k].classList.remove('selected');
        }
      }
      if (calendarCollection.clickable == true) {
        ele.classList.toggle('eventday');
        ele.classList.toggle('selected');
      }
    });
  }

  for (let k = 0; k < holidayEventDaysLength; k++) {
    holidayEventDays[k].addEventListener('click', function() {
      let ele = this;
      for (let k = 0; k < dayOpensLength; k++) {
        if (dayOpens[k] != ele && dayOpens[k].classList.contains('selected')) {
          dayOpens[k].classList.add('eventday');
          dayOpens[k].classList.remove('selected');
        }
      }
      for (let k = 0; k < holidayEventDaysLength; k++) {
        if (holidayEventDays[k] != ele && holidayEventDays[k].classList.contains('selected')) {
          holidayEventDays[k].classList.add('holiday_event');
          holidayEventDays[k].classList.remove('selected');
        }
      }
      if (calendarCollection.clickable == true) {
        ele.classList.toggle('holiday_event');
        ele.classList.toggle('selected');
      }
    });
  }
}

window.addEventListener('load', function() {
  addEventLoad();
  toggleSelectedClass();
});
